module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/mr-bit.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"March 05, 2026","title":"Mr Bit","videoUrl":"https://vimeo.com/1223236646","image":"/img/bit.jpg","credits":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/mr-bit.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-mr-bit.json
// module id = 630
// module chunks = 43525766363991